<app-sidebar>
  <div class="page">
    <div class="page-header">
      <div class="title-block">
        <h1>Digital Onboarding</h1>
        <p class="auto-update-hint" *ngIf="hasPending">
          <mat-icon>sync</mat-icon>
          Auto-updating every 30s while verification is pending
          <span *ngIf="autoUpdating">…</span>
        </p>
      </div>
      <button mat-raised-button color="primary" (click)="startNew()">
        <mat-icon>add</mat-icon>
        New Digital Onboarding
      </button>
    </div>

    <div class="loading-state" *ngIf="loading">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <div class="dovs-empty-state" *ngIf="!loading && requests.length === 0">
      <mat-icon>verified_user</mat-icon>
      <p>No digital onboarding requests yet.</p>
      <p class="dovs-empty-hint">Select the "New Digital Onboarding" button top right.</p>
    </div>

    <table mat-table [dataSource]="requests" class="mat-elevation-z0 requests-table" *ngIf="!loading && requests.length">
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>Created</th>
        <td mat-cell *matCellDef="let row">{{ row.createdAt | date: 'medium' }}</td>
      </ng-container>

      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef>Subject</th>
        <td mat-cell *matCellDef="let row">
          <span class="masked-id">{{ formatSubject(row.lookupDisplay) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">
          <span class="status" [attr.data-status]="row.status">{{ statusLabel(row.status) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef>Updated</th>
        <td mat-cell *matCellDef="let row">{{ row.updatedAt | date: 'medium' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button
            mat-icon-button
            matTooltip="Refresh status"
            *ngIf="row.status === 'PENDING_VERIFICATION'"
            [disabled]="refreshingId === row.requestId"
            (click)="refresh(row)">
            <mat-icon>refresh</mat-icon>
          </button>
          <button
            mat-icon-button
            matTooltip="View results"
            *ngIf="row.status === 'COMPLETE'"
            (click)="viewResults(row)">
            <mat-icon>visibility</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['createdAt', 'subject', 'status', 'updatedAt', 'actions']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['createdAt', 'subject', 'status', 'updatedAt', 'actions']"></tr>
    </table>
  </div>
</app-sidebar>
